import { render, staticRenderFns, recyclableRender, components } from "./haggle.vue?vue&type=template&id=58556576&"
var renderjs
import script from "./haggle.vue?vue&type=script&lang=js&"
export * from "./haggle.vue?vue&type=script&lang=js&"
import style0 from "./haggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/plus/bargain/haggle/haggle.vue"
export default component.exports